import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import EmailGroup, { newEmailGroup } from "../../models/email-groups";
import EmailGroupForm from "./EmailGroupForm";

interface EmailGroupUpdateModalProps {
  show: boolean;
  emailGroup?: EmailGroup;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const EmailGroupUpdateModal: React.FC<EmailGroupUpdateModalProps> = ({
  show,
  emailGroup,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialEmailGroup, setInitialEmailGroup] = useState<EmailGroup>(
    emailGroup ? emailGroup : newEmailGroup()
  );

  const modalTitle = emailGroup
    ? `Editar Grupo de Correo: ${emailGroup.name}`
    : `Crear Nuevo Grupo de Correo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialEmailGroup(newEmailGroup());
    onCancel();
  };
  useEffect(() => {
    setInitialEmailGroup(emailGroup ? emailGroup : newEmailGroup());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailGroup]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <EmailGroupForm
            initialEmailGroup={initialEmailGroup}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default EmailGroupUpdateModal;
